import { useQuery } from '@tanstack/react-query';
import { endpoints, ID } from '@rossum/api-client';
import { api } from '../../../../lib/apiClient';
import { credentialKeys } from './queryKeys';

export const useGetCredential = (credentialId: ID, { enabled = true } = {}) =>
  useQuery({
    queryKey: credentialKeys.detail(credentialId),
    queryFn: () =>
      api.request(endpoints.integrationCredentials.get(credentialId)),
    enabled,
  });
